module.exports = __webpack_public_path__ + "static/media/payment.0edc1d94.svg";